import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { paymentStatus } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentResult({ cancelled = false }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");

  useEffect(() => {
    if (cancelled) return;
    const sessionId = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const s = await paymentStatus(sessionId);
        if (s.payment_status === "paid") {
          await refresh();
          return setState("paid");
        }
        if (["expired", "failed"].includes(s.payment_status)) return setState("failed");
      } catch (e) {
        if (e?.response?.status === 404) return setState("failed");
      }
      if (++tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, params, refresh]);

  const copy = {
    checking: ["Confirming payment...", "Hang tight, this takes a few seconds."],
    paid: ["Payment confirmed", "Your decodes have been added to your account. Go decode something."],
    failed: ["Payment failed", "No charge was made. You can try again."],
    timeout: ["Still processing", "Your payment is taking longer than usual. Refresh in a minute."],
    cancelled: ["Checkout cancelled", "No charge was made."],
  }[state];

  return (
    <div className="min-h-screen bg-[#09090B] grid-bg flex items-center px-6" data-testid="payment-result-page">
      <div className="max-w-lg border border-white/10 bg-zinc-900/60 p-10 rounded-sm">
        <div className="font-mono-display text-[10px] tracking-[0.3em] uppercase text-emerald-500 mb-3">payment // {state}</div>
        <h1 className="font-mono-display text-3xl font-black tracking-tight mb-2" data-testid="payment-status-title">{copy[0]}</h1>
        <p className="text-zinc-400 mb-8">{copy[1]}</p>
        <Button onClick={() => navigate("/")} data-testid="back-to-app-btn"
          className="rounded-none bg-emerald-500 hover:bg-emerald-400 text-black font-mono-display text-xs tracking-[0.2em] uppercase font-bold h-11 px-6">
          Back to decoder
        </Button>
      </div>
    </div>
  );
}
